import React from 'react';
import './dashboard.css'; 
import { MdAccessTimeFilled } from 'react-icons/md'; 
import { IoMdTime } from 'react-icons/io'; 
import { LuLayoutDashboard } from "react-icons/lu";

const Dashboard = () => {
  return (
    <>
      
      <div className="header">
  <h1 className='dashboard-title'> 
    <LuLayoutDashboard /> Dashboard
  </h1>
  <div className="header-links">
    <a href='/' className="header-link">
      Not Checked-In <MdAccessTimeFilled />
    </a>
    <button className="header-button">
      10:00 pm <IoMdTime />
    </button>
    <button className="header-button">
      00:00 <IoMdTime />
    </button>
  </div>
<hr/>
</div>
       
        <div className="container-fluid">
          <section>
            <div className="row">
              {/* Dashboard Cards */}
              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    This Month's Attendance <i className="fa fa-percent"></i>
                  </div>
                  <div className="card-body text-center d-flex justify-content-center align-items-center" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">25.81%</h5>
                      <p className="card-text">Attendance Of Month</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/attendance" className="btn btn-primary">See Attendance</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    Announcements <i className="fa fa-volume-up"></i>
                  </div>
                  <div className="card-body" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">No Announcement For Today</h5>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/announcements" className="btn btn-primary">See Announcements</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    My Provident Fund <i className="fa fa-newspaper-o"></i>
                  </div>
                  <div className="card-body text-center d-flex justify-content-center align-items-center" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">26000</h5>
                      <p className="card-text">Provident Fund</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/provident-fund" className="btn btn-primary">See Provident Fund</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    Check-in-Time <i className="fa fa-newspaper-o"></i>
                  </div>
                  <div className="card-body text-center d-flex justify-content-center align-items-center" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">02:00 PM</h5>
                      <p className="card-text">My Checkin Time</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/checkin-time" className="btn btn-primary">See Checking Time Today</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    Approved Leaves <i className="fa fa-newspaper-o"></i>
                  </div>
                  <div className="card-body text-center d-flex justify-content-center align-items-center" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">04</h5>
                      <p className="card-text">Leave Approved</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/approved-leave" className="btn btn-primary">See Approved Leaves</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 p-1">
                <div className="card" id="dashboard-card">
                  <div className="card-header" id="dashboard-card-header">
                    Provident Fund <i className="fa fa-newspaper-o"></i>
                  </div>
                  <div className="card-body text-center d-flex justify-content-center align-items-center" id="dashboard-card-body">
                    <div id="announcements">
                      <h5 className="card-title">25.81%</h5>
                      <p className="card-text">Attendance Of Month</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <a href="/provident-fund" className="btn btn-primary">See Provident Fund</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </>
  );
};

export default Dashboard;  
